"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _Icon = _interopRequireDefault(require("./Icon"));
var _Text = _interopRequireDefault(require("./Text"));
var _Column = _interopRequireDefault(require("./Column"));
var _Row = _interopRequireDefault(require("./Row"));
var _theme = _interopRequireDefault(require("./styles/theme"));
var _styledComponents = _interopRequireWildcard(require("styled-components"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
(function () {
  var enterModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.enterModule : undefined;
  enterModule && enterModule(module);
})();
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
var __signature__ = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal["default"].signature : function (a) {
  return a;
};
var DropdownContainer = _styledComponents["default"].div.withConfig({
  displayName: "DropdownContainer",
  componentId: "sc-5eb000-0"
})(["display:flex;flex-direction:column;position:relative;min-width:200px;max-width:320px;user-select:none;-webkit-user-select:none;-moz-user-select:none;-ms-user-select:none;"]);
var DropdownList = _styledComponents["default"].ul.withConfig({
  displayName: "DropdownList",
  componentId: "sc-5eb000-1"
})(["z-index:10;width:100%;box-shadow:0 4px 7px rgba(39,43,52,0.08);background-color:", ";max-height:215px;overflow-y:auto;-webkit-overflow-scrolling:touch;position:absolute;"], _theme["default"].white);
/* istanbul ignore next */
var DropdownListItem = _styledComponents["default"].li.withConfig({
  displayName: "DropdownListItem",
  componentId: "sc-5eb000-2"
})(["width:100%;border-bottom:1px solid ", ";padding:8px 10px;cursor:default;display:inline-block;", ";}"], _theme["default"].lightGrey, function (props) {
  return props.isSelected && (0, _styledComponents.css)(["background:", ";color:", ";"], _theme["default"].info, _theme["default"].white);
});
var IconContainer = _styledComponents["default"].div.withConfig({
  displayName: "IconContainer",
  componentId: "sc-5eb000-3"
})(["width:24px;height:24px;svg{font-size:24px;font-align:right;}"]);
var IconSpan = _styledComponents["default"].span.withConfig({
  displayName: "IconSpan",
  componentId: "sc-5eb000-4"
})(["float:right;"]);
var BorderContainer = _styledComponents["default"].div.withConfig({
  displayName: "BorderContainer",
  componentId: "sc-5eb000-5"
})(["border-bottom:1px solid ", ";"], _theme["default"].lightGrey);
var HeaderContainer = _styledComponents["default"].div.withConfig({
  displayName: "HeaderContainer",
  componentId: "sc-5eb000-6"
})(["width:100%;line-height:38px;cursor:default;background-color:", ";"], _theme["default"].white);
var Dropdown = /*#__PURE__*/function (_Component) {
  _inherits(Dropdown, _Component);
  var _super = _createSuper(Dropdown);
  function Dropdown(props) {
    var _this;
    _classCallCheck(this, Dropdown);
    _this = _super.call(this, props);
    _this.state = {
      listOpen: false
    };
    _this.close = _this.close.bind(_assertThisInitialized(_this));
    return _this;
  }

  /* istanbul ignore next */
  _createClass(Dropdown, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      if (!this.props.label) {
        this.setState({
          headerTitle: this.props.list[0]
        });
      }
    }

    /* istanbul ignore next */
  }, {
    key: "close",
    value: function close(timeOut) {
      this.setState({
        listOpen: false
      });
    }
  }, {
    key: "onListItemClick",
    value: function onListItemClick(item, index) {
      this.setState({
        headerTitle: item,
        listOpen: false
      }, this.props.onListItemClick(item, index));
    }
  }, {
    key: "toggleList",
    value: function toggleList() {
      this.setState(function (prevState) {
        return {
          listOpen: !prevState.listOpen
        };
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;
      var list = this.props.list;
      var _this$state = this.state,
        listOpen = _this$state.listOpen,
        headerTitle = _this$state.headerTitle;
      return /*#__PURE__*/_react["default"].createElement(DropdownContainer, {
        onClick: function onClick() {
          return _this2.toggleList();
        }
      }, /*#__PURE__*/_react["default"].createElement(BorderContainer, null, /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        classNames: ['is-marginless', 'is-mobile']
      }, /*#__PURE__*/_react["default"].createElement(_Column["default"], {
        classNames: ['is-paddingless']
      }, /*#__PURE__*/_react["default"].createElement(HeaderContainer, null, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
        textSize: "h4",
        fontColor: headerTitle ? _theme["default"].lightTextDefault : _theme["default"].disabled,
        text: headerTitle || this.props.label
      }))), /*#__PURE__*/_react["default"].createElement(_Column["default"], {
        classNames: ['is-1', 'is-paddingless']
      }, /*#__PURE__*/_react["default"].createElement(IconSpan, null, /*#__PURE__*/_react["default"].createElement(IconContainer, null, listOpen ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        color: _theme["default"].lightGrey,
        iconName: "angleUp"
      }) : /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
        color: _theme["default"].lightGrey,
        iconName: "angleDown"
      })))))), /*#__PURE__*/_react["default"].createElement(_Row["default"], {
        classNames: ['is-marginless', 'is-mobile']
      }, /*#__PURE__*/_react["default"].createElement(_Column["default"], {
        classNames: ['is-paddingless']
      }, listOpen && /*#__PURE__*/_react["default"].createElement(DropdownList, {
        onClick: function onClick(e) {
          return e.stopPropagation();
        }
      }, list.map(function (item, index) {
        return /*#__PURE__*/_react["default"].createElement(DropdownListItem, {
          key: index,
          isSelected: headerTitle === item,
          onClick: function onClick() {
            return _this2.onListItemClick(item, index);
          }
        }, /*#__PURE__*/_react["default"].createElement(_Text["default"], {
          textSize: "h4",
          text: item
        }), " ");
      })))));
    }
  }, {
    key: "__reactstandin__regenerateByEval",
    value: // @ts-ignore
    function __reactstandin__regenerateByEval(key, code) {
      // @ts-ignore
      this[key] = eval(code);
    }
  }]);
  return Dropdown;
}(_react.Component);
var _default = Dropdown;
var _default2 = _default;
exports["default"] = _default2;
;
(function () {
  var reactHotLoader = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.default : undefined;
  if (!reactHotLoader) {
    return;
  }
  reactHotLoader.register(DropdownContainer, "DropdownContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
  reactHotLoader.register(DropdownList, "DropdownList", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
  reactHotLoader.register(DropdownListItem, "DropdownListItem", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
  reactHotLoader.register(IconContainer, "IconContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
  reactHotLoader.register(IconSpan, "IconSpan", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
  reactHotLoader.register(BorderContainer, "BorderContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
  reactHotLoader.register(HeaderContainer, "HeaderContainer", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
  reactHotLoader.register(Dropdown, "Dropdown", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
  reactHotLoader.register(_default, "default", "/Users/crs/WebstormProjects/michelangelo/src/Components/Dropdown.js");
})();
;
(function () {
  var leaveModule = typeof reactHotLoaderGlobal !== 'undefined' ? reactHotLoaderGlobal.leaveModule : undefined;
  leaveModule && leaveModule(module);
})();